import React from 'react';
import Avatar from '../assets/images/users/avt1.png'
import { BiCalendar, BiLogOut, BiListUl, BiWorld, BiLayout, BiEnvelope, BiIdCard, BiHistory } from "react-icons/bi";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    useMsal,
    MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { UserRole } from '../callMsGroup';
import { getRealRole } from '../utils/roleOverride';

const NAV = {
    events:      'Events',
    myevents:    'My Events',
    templates:   'Forms',
    labels:      'Language Labels',
    emailcfg:    'Email Configuration',
    cardno:      'Update Card No',
    webhooklogs: 'Webhook Logs',
    logout:      'Logout',
    menu:        'Menu',
};

export default function Topbar(props: { role?: UserRole; isAdmin?: boolean; photoData?: string; token?: string; triggerSearch?: (kw: string) => void; [k: string]: any }) {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const location = useLocation();
    const nav = (key: keyof typeof NAV) => NAV[key];
    const isActive = (path: string) =>
        (location.pathname === path || location.pathname.startsWith(path + '/') || (path === '/forms' && location.pathname.startsWith('/form')))
            ? 'sidebar-nav-item active' : 'sidebar-nav-item';

    const realRole = getRealRole();
    const role: UserRole = realRole === 'superadmin'
        ? 'superadmin'
        : props.role ?? realRole ?? (props.isAdmin ? 'admin' : 'owner');
    const isSuperAdmin = role === 'superadmin';
    const isAdminRole = role === 'admin';
    const canSeeEventMenus = isAdminRole || isSuperAdmin;
    const canSeeFormsMenu = isAdminRole || isSuperAdmin;

    const handleLogout = () => {
        instance.logoutRedirect({ postLogoutRedirectUri: "/" });
    };

    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
            <aside className="admin-sidebar">
                {/* Logo */}
                <div className="sidebar-brand" onClick={() => navigate(isSuperAdmin ? '/forms' : '/admin')} style={{ cursor: 'pointer' }}>
                    <span className="sidebar-brand-text">C&amp;S EVENTS PPV</span>
                </div>

                {/* Navigation */}
                <nav className="sidebar-nav">
                    <div className="sidebar-nav-label">{nav('menu')}</div>
                    {canSeeEventMenus && (
                        <button className={isActive('/admin')} onClick={() => navigate('/admin')}>
                            <BiCalendar size={18} /> <span>{nav('events')}</span>
                        </button>
                    )}
                    {!isSuperAdmin && (
                        <button className={isActive('/myevents')} onClick={() => navigate('/myevents')}>
                            <BiListUl size={18} /> <span>{nav('myevents')}</span>
                        </button>
                    )}
                    {canSeeFormsMenu && (
                        <button className={isActive('/forms')} onClick={() => navigate('/forms')}>
                            <BiLayout size={18} /> <span>{nav('templates')}</span>
                        </button>
                    )}
                    {canSeeEventMenus && (
                        <button className={isActive('/language-labels')} onClick={() => navigate('/language-labels')}>
                            <BiWorld size={18} /> <span>{nav('labels')}</span>
                        </button>
                    )}
                    {isSuperAdmin && (
                        <>
                            <button className={isActive('/email-config')} onClick={() => navigate('/email-config')}>
                                <BiEnvelope size={18} /> <span>{nav('emailcfg')}</span>
                            </button>
                            <button className={isActive('/update-card-no')} onClick={() => navigate('/update-card-no')}>
                                <BiIdCard size={18} /> <span>{nav('cardno')}</span>
                            </button>
                            <button className={isActive('/webhook-logs')} onClick={() => navigate('/webhook-logs')}>
                                <BiHistory size={18} /> <span>{nav('webhooklogs')}</span>
                            </button>
                        </>
                    )}
                </nav>

                {/* Spacer */}
                <div style={{ flex: 1 }} />

                {/* Profile + Logout */}
                <div className="sidebar-footer">
                    <div className="sidebar-profile">
                        <img
                            src={props.photoData || Avatar}
                            className="sidebar-avatar"
                            alt="avatar"
                        />
                        <div className="sidebar-profile-info">
                            <div className="sidebar-profile-name">{accounts[0]?.name}</div>
                        </div>
                    </div>
                    <button className="sidebar-logout-btn" onClick={handleLogout}>
                        <BiLogOut size={16} /> {nav('logout')}
                    </button>
                </div>
            </aside>
        </MsalAuthenticationTemplate>
    );
}
